"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.API = void 0;
var FetchRequest_1 = require("../request/FetchRequest");
var TranSend_1 = require("./TranSend");
var Base58_1 = require("../crypt/libs/Base58");
var Qora_1 = require("../crypt/libs/Qora");
var BigDecimal_1 = require("../src/BigDecimal");
var TranMessage_1 = require("./TranMessage");
var TranPerson_1 = require("./TranPerson");
var TranAsset_1 = require("./TranAsset");
var TranPersonVerify_1 = require("./TranPersonVerify");
var TranOrder_1 = require("./TranOrder");
var TranCancelOrder_1 = require("./TranCancelOrder");
var IApiConfig_1 = require("../types/era/IApiConfig");
var TranDocument_1 = require("./TranDocument");
var TranSign_1 = require("./TranSign");
var TranImprint_1 = require("./TranImprint");
var TranTemplate_1 = require("./TranTemplate");
var TranUpdateOrder_1 = require("./TranUpdateOrder");
var TranTypes_1 = require("../src/core/transaction/TranTypes");
var fetch = require('node-fetch');
var url = require('url');
var TypeTransaction;
(function (TypeTransaction) {
    TypeTransaction[TypeTransaction["SEND"] = 31] = "SEND";
    TypeTransaction[TypeTransaction["ORDER"] = 50] = "ORDER";
    TypeTransaction[TypeTransaction["CANCEL_ORDER"] = 51] = "CANCEL_ORDER";
    TypeTransaction[TypeTransaction["ASSET"] = 21] = "ASSET";
    TypeTransaction[TypeTransaction["PERSON"] = 24] = "PERSON";
    TypeTransaction[TypeTransaction["CALC"] = 100] = "CALC";
})(TypeTransaction || (TypeTransaction = {}));
var API = /** @class */ (function () {
    function API(baseUrl, rpcPort, config) {
        this.request = new FetchRequest_1.FetchRequest(baseUrl);
        this.rpcPort = rpcPort;
        this.genesis_sign = new Int8Array([]);
        this.url = url.parse(baseUrl);
        if (config) {
            API.CHAIN_MODE = config.mode;
            this.genesis = config.genesis;
        }
        else {
            this.setMode();
        }
    }
    API.prototype.setMode = function () {
        API.CHAIN_MODE = IApiConfig_1.ChainMode.DEFAULT;
        var part = Math.trunc(this.rpcPort / 10);
        if (part === 905 || part === 907) {
            API.CHAIN_MODE = IApiConfig_1.ChainMode.SIDE;
        }
        else if (part === 909) {
            API.CHAIN_MODE = IApiConfig_1.ChainMode.CLONE;
        }
    };
    Object.defineProperty(API.prototype, "mode", {
        get: function () {
            return API.CHAIN_MODE;
        },
        set: function (mode) {
            if (mode === IApiConfig_1.ChainMode.DEFAULT || mode === IApiConfig_1.ChainMode.SIDE || mode === IApiConfig_1.ChainMode.CLONE) {
                API.CHAIN_MODE = mode;
            }
            else {
                throw new Error("Invalid mode. Expected either: " + IApiConfig_1.ChainMode.DEFAULT + ", " + IApiConfig_1.ChainMode.SIDE + ", " + IApiConfig_1.ChainMode.CLONE);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(API.prototype, "sidechainMode", {
        get: function () {
            return API.CHAIN_MODE !== IApiConfig_1.ChainMode.DEFAULT;
        },
        enumerable: false,
        configurable: true
    });
    API.prototype.genesisSignature = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, block, sign, _b, e_1;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (this.genesis_sign.length > 0) {
                            return [2 /*return*/, this.genesis_sign];
                        }
                        _c.label = 1;
                    case 1:
                        _c.trys.push([1, 6, , 7]);
                        if (!this.genesis) return [3 /*break*/, 3];
                        _a = this;
                        return [4 /*yield*/, Base58_1.Base58.decode(this.genesis)];
                    case 2:
                        _a.genesis_sign = _c.sent();
                        return [2 /*return*/, this.genesis_sign];
                    case 3: return [4 /*yield*/, this.request.block.firstBlock()];
                    case 4:
                        block = _c.sent();
                        sign = block.signatures[0];
                        this.genesis = sign;
                        _b = this;
                        return [4 /*yield*/, Base58_1.Base58.decode(sign)];
                    case 5:
                        _b.genesis_sign = _c.sent();
                        return [3 /*break*/, 7];
                    case 6:
                        e_1 = _c.sent();
                        this.genesis_sign = new Int8Array([]);
                        throw new Error("Genesis signature retrieval error: " + e_1.message);
                    case 7: return [2 /*return*/, this.genesis_sign];
                }
            });
        });
    };
    // APIInterface
    API.prototype.query = function (method, path, headers, params, body) {
        return __awaiter(this, void 0, void 0, function () {
            var strParams, sep, _a, _b, _c, key, value;
            var e_2, _d;
            return __generator(this, function (_e) {
                path = path.trim();
                if (!path.startsWith('/')) {
                    path = "/" + path;
                }
                strParams = '';
                if (params) {
                    if (method === 'post' || method === 'POST') {
                        body = JSON.stringify(params);
                    }
                    else {
                        sep = '?';
                        try {
                            for (_a = __values(Object.entries(params)), _b = _a.next(); !_b.done; _b = _a.next()) {
                                _c = __read(_b.value, 2), key = _c[0], value = _c[1];
                                if (strParams.length > 0) {
                                    sep = '&';
                                }
                                strParams += "" + sep + key + "=" + encodeURIComponent(value);
                            }
                        }
                        catch (e_2_1) { e_2 = { error: e_2_1 }; }
                        finally {
                            try {
                                if (_b && !_b.done && (_d = _a.return)) _d.call(_a);
                            }
                            finally { if (e_2) throw e_2.error; }
                        }
                    }
                }
                return [2 /*return*/, fetch(this.url.protocol + "//" + this.url.host + path + strParams, { method: method, headers: headers, body: body })
                        .then(function (r) {
                        if (r.status < 200 || r.status >= 300) {
                            throw new Error(r.status.toString());
                        }
                        return r;
                    })
                        .catch(function (e) {
                        throw new Error(e);
                    })];
            });
        });
    };
    API.prototype.getInfo = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.request.block.info()];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    API.prototype.height = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.request.block.height()];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    API.prototype.firstBlock = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.request.block.firstBlock()];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    API.prototype.lastBlock = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.request.block.lastBlock()];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    API.prototype.blocksFromHeight = function (height, limit) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.request.blocks.blocksFromHeight(height, limit)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    API.prototype.blockByHeight = function (height) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.request.block.blockByHeight(height)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    API.prototype.getLastReference = function (address) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.request.address.lastReference(address)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    API.prototype.getPublicKeyByAddress = function (address) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.request.address.addresspublickey(address)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    API.prototype.orderBook = function (wantAssetKey, haveAssetKey, limit) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.request.exchange.orders(wantAssetKey, haveAssetKey, limit)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    API.prototype.lastTrade = function (wantAssetKey, haveAssetKey) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.request.exchange.lasttrade(wantAssetKey, haveAssetKey)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    API.prototype.playOrders = function (wantAssetKey, haveAssetKey) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.request.exchange.playOrders(wantAssetKey, haveAssetKey)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    API.prototype.tradesAll = function (wantAssetKey, haveAssetKey, orderID, limit) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.request.exchange.tradesAll(wantAssetKey, haveAssetKey, orderID, limit)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    API.prototype.orderBySign = function (signature) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.request.exchange.order(signature)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    API.prototype.getTransactions = function (address, heightOfBlock, offsetInBlock, pageSize) {
        return __awaiter(this, void 0, void 0, function () {
            var data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.request.records.findAll(address, heightOfBlock, offsetInBlock, pageSize).catch(function (e) {
                            throw new Error(e);
                        })];
                    case 1:
                        data = _a.sent();
                        return [2 /*return*/, data];
                }
            });
        });
    };
    API.prototype.find = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.request.records.find(args)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    API.prototype.tranBySeq = function (seqNo) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.request.records.getTransaction(seqNo)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    API.prototype.getAssetTransactions = function (address, assetKey, offset, pageSize, type) {
        return __awaiter(this, void 0, void 0, function () {
            var data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.request.records
                            .getbyaddressfromtransactionlimit(address, assetKey, offset, offset + pageSize, type)
                            .catch(function (e) {
                            throw new Error(e);
                        })];
                    case 1:
                        data = _a.sent();
                        return [2 /*return*/, data];
                }
            });
        });
    };
    API.prototype.getAllAssets = function () {
        return __awaiter(this, void 0, void 0, function () {
            var data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.request.assets.assets().catch(function (e) {
                            throw new Error(e);
                        })];
                    case 1:
                        data = _a.sent();
                        return [2 /*return*/, data];
                }
            });
        });
    };
    API.prototype.getAsset = function (assetKey) {
        return __awaiter(this, void 0, void 0, function () {
            var data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.request.assets.asset(assetKey.toString()).catch(function (e) {
                            throw new Error(e);
                        })];
                    case 1:
                        data = _a.sent();
                        return [2 /*return*/, data];
                }
            });
        });
    };
    API.prototype.getAllBalance = function (address) {
        return __awaiter(this, void 0, void 0, function () {
            var data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.request.assets.addressassets(address).catch(function (e) {
                            throw new Error(e);
                        })];
                    case 1:
                        data = _a.sent();
                        return [2 /*return*/, data];
                }
            });
        });
    };
    API.prototype.getBalance = function (address, assetKey) {
        return __awaiter(this, void 0, void 0, function () {
            var data, num;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.request.assets.assetBalance(address, assetKey).catch(function (e) {
                            throw new Error(e);
                        })];
                    case 1:
                        data = _a.sent();
                        if (data && data.length > 0 && data[0] && data[0].length >= 2) {
                            num = data[0][1];
                            if (!Number.isNaN(Number(num))) {
                                return [2 /*return*/, num];
                            }
                        }
                        throw new Error('Balance error');
                }
            });
        });
    };
    API.prototype.getAssetData = function (assetKey) {
        return __awaiter(this, void 0, void 0, function () {
            var data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.request.assets.data(assetKey).catch(function (e) {
                            throw new Error(e);
                        })];
                    case 1:
                        data = _a.sent();
                        return [2 /*return*/, data];
                }
            });
        });
    };
    API.prototype.getAssetImage = function (assetKey) {
        return __awaiter(this, void 0, void 0, function () {
            var data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.request.assets.assetimage(assetKey).catch(function (e) {
                            throw new Error(e);
                        })];
                    case 1:
                        data = _a.sent();
                        return [2 /*return*/, data];
                }
            });
        });
    };
    API.prototype.getAssetIcon = function (assetKey) {
        return __awaiter(this, void 0, void 0, function () {
            var data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.request.assets.asseticon(assetKey).catch(function (e) {
                            throw new Error(e);
                        })];
                    case 1:
                        data = _a.sent();
                        return [2 /*return*/, data];
                }
            });
        });
    };
    API.prototype.getAssetsByFilter = function (filter) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.request.assets.assetsfilter(filter)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    API.prototype.getTelegrams = function (address, fromTimestamp) {
        return __awaiter(this, void 0, void 0, function () {
            var data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.request.telegram.getfind(address, fromTimestamp).catch(function (e) {
                            throw new Error(e);
                        })];
                    case 1:
                        data = _a.sent();
                        return [2 /*return*/, data];
                }
            });
        });
    };
    API.prototype.getPersonsByFilter = function (filter) {
        return __awaiter(this, void 0, void 0, function () {
            var data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.request.person.personsfilter(filter).catch(function (e) {
                            throw new Error(e);
                        })];
                    case 1:
                        data = _a.sent();
                        return [2 /*return*/, data];
                }
            });
        });
    };
    API.prototype.getPersonData = function (personKey) {
        return __awaiter(this, void 0, void 0, function () {
            var data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.request.person.persondata(personKey).catch(function (e) {
                            throw new Error(e);
                        })];
                    case 1:
                        data = _a.sent();
                        return [2 /*return*/, data];
                }
            });
        });
    };
    API.prototype.getPersonImage = function (key) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.request.person.getPersonImage(key)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    API.prototype.getPerson = function (personKey) {
        return __awaiter(this, void 0, void 0, function () {
            var data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.request.person.person(personKey).catch(function (e) {
                            throw new Error(e);
                        })];
                    case 1:
                        data = _a.sent();
                        return [2 /*return*/, data];
                }
            });
        });
    };
    API.prototype.getPersonByAddress = function (address) {
        return __awaiter(this, void 0, void 0, function () {
            var data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.request.person.personbyaddress(address).catch(function (e) {
                            throw new Error(e);
                        })];
                    case 1:
                        data = _a.sent();
                        return [2 /*return*/, data];
                }
            });
        });
    };
    API.prototype.getPersonByPublicKey = function (base58key) {
        return __awaiter(this, void 0, void 0, function () {
            var data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.request.persons.personbypublickey(base58key).catch(function (e) {
                            throw new Error(e);
                        })];
                    case 1:
                        data = _a.sent();
                        return [2 /*return*/, data];
                }
            });
        });
    };
    // SDK
    /** @description API broadcast.
     * @param {string} raw Raw data.
     * @return {Promise<IBroadcastResponse>}
     */
    API.prototype.broadcast = function (raw) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.request.broadcast.broadcastPost(raw)
                            .catch(function (e) {
                            throw new Error(e);
                        })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /** @description API broadcast.
     * @param {string} raw Base64 raw data.
     * @return {Promise<IBroadcastResponse>}
     */
    API.prototype.broadcast64 = function (raw) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.request.broadcast.broadcastPost64(raw)
                            .catch(function (e) {
                            throw new Error(e);
                        })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /** @description API send amount of asset to recipient.
     * @param {KeyPair} keyPair Key pair.
     * @param {IAsset} asset Amount and asset key.
     * @param {string} recipientPublicKey Recipient public key.
     * @param {string} head Title.
     * @param {string} message Message.
     * @param {boolean} encrypted Encryption flag.
     * @param {boolean} isBase64 Base64 encoding.
     * @return {Promise<IBroadcastResponse>}
     */
    API.prototype.sendAsset = function (keyPair, asset, recipientPublicKey, head, message, encrypted, isBase64) {
        return __awaiter(this, void 0, void 0, function () {
            var recipient, pk, _a, tranBody, transAsset, genesis_sign, _b, tran, data, data;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        recipient = {
                            address: recipientPublicKey,
                            publicKey: null,
                        };
                        if (!(recipientPublicKey.length >= 43)) return [3 /*break*/, 3];
                        return [4 /*yield*/, Base58_1.Base58.decode(recipientPublicKey)];
                    case 1:
                        pk = _c.sent();
                        _a = {};
                        return [4 /*yield*/, Qora_1.Qora.getAccountAddressFromPublicKey(pk)];
                    case 2:
                        recipient = (_a.address = _c.sent(),
                            _a.publicKey = pk,
                            _a);
                        _c.label = 3;
                    case 3:
                        tranBody = {
                            head: head,
                            message: message,
                            encrypted: encrypted,
                        };
                        transAsset = {
                            assetKey: asset.assetKey,
                            amount: new BigDecimal_1.BigDecimal(asset.amount),
                        };
                        if (!this.sidechainMode) return [3 /*break*/, 5];
                        return [4 /*yield*/, this.genesisSignature()];
                    case 4:
                        _b = _c.sent();
                        return [3 /*break*/, 6];
                    case 5:
                        _b = new Int8Array([]);
                        _c.label = 6;
                    case 6:
                        genesis_sign = _b;
                        return [4 /*yield*/, TranSend_1.tranSend(recipient, keyPair, transAsset, tranBody, this.rpcPort, genesis_sign, isBase64)];
                    case 7:
                        tran = _c.sent();
                        if (!!tran.error) return [3 /*break*/, 12];
                        if (!isBase64) return [3 /*break*/, 9];
                        return [4 /*yield*/, this.request.broadcast.broadcastPost64(tran.raw).catch(function (e) {
                                throw new Error(e);
                            })];
                    case 8:
                        data = _c.sent();
                        return [2 /*return*/, data];
                    case 9: return [4 /*yield*/, this.request.broadcast.broadcastPost(tran.raw).catch(function (e) {
                            throw new Error(e);
                        })];
                    case 10:
                        data = _c.sent();
                        return [2 /*return*/, data];
                    case 11: return [3 /*break*/, 13];
                    case 12: throw new Error(tran.error);
                    case 13: return [2 /*return*/];
                }
            });
        });
    };
    /** @description API gets raw send amount of asset to recipient.
     * @param {KeyPair} keyPair Key pair.
     * @param {IAsset} asset Amount and asset key.
     * @param {string} recipientPublicKey Recipient public key.
     * @param {string} head Title.
     * @param {string} message Message.
     * @param {boolean} encrypted Encryption flag.
     * @param {boolean} isBase64 Base64 encoding.
     * @param {ETransferType} transferType Transfer type.
     * @return {Promise<IBroadcastResponse>}
     */
    API.prototype.tranRawSendAsset = function (keyPair, asset, recipientPublicKey, head, message, encrypted, isBase64, transferType) {
        if (transferType === void 0) { transferType = TranTypes_1.ETransferType.DEFAULT; }
        return __awaiter(this, void 0, void 0, function () {
            var recipient, pk, _a, tranBody, transAsset, genesis_sign, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        recipient = {
                            address: recipientPublicKey,
                            publicKey: null,
                        };
                        if (!(recipientPublicKey.length >= 43)) return [3 /*break*/, 3];
                        return [4 /*yield*/, Base58_1.Base58.decode(recipientPublicKey)];
                    case 1:
                        pk = _c.sent();
                        _a = {};
                        return [4 /*yield*/, Qora_1.Qora.getAccountAddressFromPublicKey(pk)];
                    case 2:
                        recipient = (_a.address = _c.sent(),
                            _a.publicKey = pk,
                            _a);
                        _c.label = 3;
                    case 3:
                        tranBody = {
                            head: head,
                            message: message,
                            encrypted: encrypted,
                        };
                        transAsset = {
                            assetKey: asset.assetKey,
                            amount: new BigDecimal_1.BigDecimal(asset.amount),
                        };
                        if (!this.sidechainMode) return [3 /*break*/, 5];
                        return [4 /*yield*/, this.genesisSignature()];
                    case 4:
                        _b = _c.sent();
                        return [3 /*break*/, 6];
                    case 5:
                        _b = new Int8Array([]);
                        _c.label = 6;
                    case 6:
                        genesis_sign = _b;
                        return [4 /*yield*/, TranSend_1.tranSend(recipient, keyPair, transAsset, tranBody, this.rpcPort, genesis_sign, isBase64, transferType)];
                    case 7: return [2 /*return*/, _c.sent()];
                }
            });
        });
    };
    /** @description API get transaction raw of person.
     * @param {KeyPair} keyPair Key pair.
     * @param {PersonHuman} person Person.
     * @return {Promise<ITranRaw>}
     */
    API.prototype.tranRawPerson = function (keyPair, person, isBase64) {
        return __awaiter(this, void 0, void 0, function () {
            var genesis_sign, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!this.sidechainMode) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.genesisSignature()];
                    case 1:
                        _a = _b.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        _a = new Int8Array([]);
                        _b.label = 3;
                    case 3:
                        genesis_sign = _a;
                        return [4 /*yield*/, TranPerson_1.tranPerson(keyPair, person, this.rpcPort, genesis_sign, isBase64)];
                    case 4: return [2 /*return*/, _b.sent()];
                }
            });
        });
    };
    /** @description API get transaction raw of person with certification.
     * @param {KeyPair} keyPair Key pair.
     * @param {PersonHuman} person Person.
     * @return {Promise<ITranRaw>}
     */
    API.prototype.tranRawPersonCertify = function (keyPair, person, isBase64) {
        return __awaiter(this, void 0, void 0, function () {
            var genesis_sign, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!this.sidechainMode) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.genesisSignature()];
                    case 1:
                        _a = _b.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        _a = new Int8Array([]);
                        _b.label = 3;
                    case 3:
                        genesis_sign = _a;
                        return [4 /*yield*/, TranPerson_1.tranPerson(keyPair, person, this.rpcPort, genesis_sign, isBase64, true)];
                    case 4: return [2 /*return*/, _b.sent()];
                }
            });
        });
    };
    /** @description API verify person.
     * @param {KeyPair} keyPair Key pair.
     * @param {number} personKey Person key ID.
     * @param {Int8Array} personPublicKey Person public key.
     * @return {Promise<ITranRaw>}
     */
    API.prototype.tranRawVerifyPerson = function (keyPair, personKey, personPublicKey, isBase64) {
        return __awaiter(this, void 0, void 0, function () {
            var reference, genesis_sign, _a, e_3;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 5, , 6]);
                        reference = 0;
                        if (!this.sidechainMode) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.genesisSignature()];
                    case 1:
                        _a = _b.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        _a = new Int8Array([]);
                        _b.label = 3;
                    case 3:
                        genesis_sign = _a;
                        return [4 /*yield*/, TranPersonVerify_1.tranVerifyPerson(keyPair, personKey, personPublicKey, reference, this.rpcPort, genesis_sign, isBase64)];
                    case 4: return [2 /*return*/, _b.sent()];
                    case 5:
                        e_3 = _b.sent();
                        throw e_3;
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    /** @description API verify person.
     * @param {KeyPair} keyPair Key pair.
     * @param {number} personKey Person key ID.
     * @param {Int8Array} personPublicKey Person public key.
     * @return {Promise<IBroadcastResponse>}
     */
    API.prototype.verifyPerson = function (keyPair, personKey, personPublicKey, isBase64) {
        return __awaiter(this, void 0, void 0, function () {
            var reference, genesis_sign, _a, tran, data, data, e_4;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 11, , 12]);
                        reference = 0;
                        if (!this.sidechainMode) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.genesisSignature()];
                    case 1:
                        _a = _b.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        _a = new Int8Array([]);
                        _b.label = 3;
                    case 3:
                        genesis_sign = _a;
                        return [4 /*yield*/, TranPersonVerify_1.tranVerifyPerson(keyPair, personKey, personPublicKey, reference, this.rpcPort, genesis_sign, isBase64)];
                    case 4:
                        tran = _b.sent();
                        if (!!tran.error) return [3 /*break*/, 9];
                        if (!isBase64) return [3 /*break*/, 6];
                        return [4 /*yield*/, this.request.broadcast.broadcastPost64(tran.raw).catch(function (e) {
                                throw new Error(e);
                            })];
                    case 5:
                        data = _b.sent();
                        return [2 /*return*/, data];
                    case 6: return [4 /*yield*/, this.request.broadcast.broadcastPost(tran.raw).catch(function (e) {
                            throw new Error(e);
                        })];
                    case 7:
                        data = _b.sent();
                        return [2 /*return*/, data];
                    case 8: return [3 /*break*/, 10];
                    case 9: throw new Error(tran.error);
                    case 10: return [3 /*break*/, 12];
                    case 11:
                        e_4 = _b.sent();
                        throw e_4;
                    case 12: return [2 /*return*/];
                }
            });
        });
    };
    /** @description API raw data for sending message.
     * @param {KeyPair} keyPair Key pair.
     * @param {string} recipientPublicKey Recipient public key.
     * @param {string} head Title.
     * @param {string} message Message.
     * @param {boolean} encrypted Encryption flag.
     * @return {Promise<ITranRaw>}
     */
    API.prototype.tranRawMessage = function (keyPair, recipientPublicKey, head, message, encrypted, isBase64) {
        return __awaiter(this, void 0, void 0, function () {
            var recipient, pk, _a, tranBody, genesis_sign, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        recipient = {
                            address: recipientPublicKey,
                            publicKey: null,
                        };
                        if (!(recipientPublicKey.length >= 43)) return [3 /*break*/, 3];
                        return [4 /*yield*/, Base58_1.Base58.decode(recipientPublicKey)];
                    case 1:
                        pk = _c.sent();
                        _a = {};
                        return [4 /*yield*/, Qora_1.Qora.getAccountAddressFromPublicKey(pk)];
                    case 2:
                        recipient = (_a.address = _c.sent(),
                            _a.publicKey = pk,
                            _a);
                        _c.label = 3;
                    case 3:
                        tranBody = {
                            head: head,
                            message: message,
                            encrypted: encrypted,
                        };
                        if (!this.sidechainMode) return [3 /*break*/, 5];
                        return [4 /*yield*/, this.genesisSignature()];
                    case 4:
                        _b = _c.sent();
                        return [3 /*break*/, 6];
                    case 5:
                        _b = new Int8Array([]);
                        _c.label = 6;
                    case 6:
                        genesis_sign = _b;
                        return [4 /*yield*/, TranMessage_1.tranMessage(recipient, keyPair, tranBody, this.rpcPort, genesis_sign, isBase64)];
                    case 7: return [2 /*return*/, _c.sent()];
                }
            });
        });
    };
    /** @description API send message.
     * @param {KeyPair} keyPair Key pair.
     * @param {string} recipientPublicKey Recipient public key.
     * @param {string} head Title.
     * @param {string} message Message.
     * @param {boolean} encrypted Encryption flag.
     * @return {Promise<IBroadcastResponse>}
     */
    API.prototype.sendMessage = function (keyPair, recipientPublicKey, head, message, encrypted, isBase64) {
        return __awaiter(this, void 0, void 0, function () {
            var recipient, pk, _a, tranBody, genesis_sign, _b, tran, data, data;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        recipient = {
                            address: recipientPublicKey,
                            publicKey: null,
                        };
                        if (!(recipientPublicKey.length >= 43)) return [3 /*break*/, 3];
                        return [4 /*yield*/, Base58_1.Base58.decode(recipientPublicKey)];
                    case 1:
                        pk = _c.sent();
                        _a = {};
                        return [4 /*yield*/, Qora_1.Qora.getAccountAddressFromPublicKey(pk)];
                    case 2:
                        recipient = (_a.address = _c.sent(),
                            _a.publicKey = pk,
                            _a);
                        _c.label = 3;
                    case 3:
                        tranBody = {
                            head: head,
                            message: message,
                            encrypted: encrypted,
                        };
                        if (!this.sidechainMode) return [3 /*break*/, 5];
                        return [4 /*yield*/, this.genesisSignature()];
                    case 4:
                        _b = _c.sent();
                        return [3 /*break*/, 6];
                    case 5:
                        _b = new Int8Array([]);
                        _c.label = 6;
                    case 6:
                        genesis_sign = _b;
                        return [4 /*yield*/, TranMessage_1.tranMessage(recipient, keyPair, tranBody, this.rpcPort, genesis_sign, isBase64)];
                    case 7:
                        tran = _c.sent();
                        if (!!tran.error) return [3 /*break*/, 12];
                        if (!isBase64) return [3 /*break*/, 9];
                        return [4 /*yield*/, this.request.broadcast.broadcastPost64(tran.raw).catch(function (e) {
                                throw new Error(e);
                            })];
                    case 8:
                        data = _c.sent();
                        return [2 /*return*/, data];
                    case 9: return [4 /*yield*/, this.request.broadcast.broadcastPost(tran.raw).catch(function (e) {
                            throw new Error(e);
                        })];
                    case 10:
                        data = _c.sent();
                        return [2 /*return*/, data];
                    case 11: return [3 /*break*/, 13];
                    case 12: throw new Error(tran.error);
                    case 13: return [2 /*return*/];
                }
            });
        });
    };
    /** @description API raw data for sending telegram.
     * @param {KeyPair} keyPair Key pair.
     * @param {string} recipientPublicKey Recipient public key.
     * @param {string} message Message.
     * @param {boolean} encrypted Encryption flag.
     * @return {Promise<ITranRaw>}
     */
    API.prototype.tranRawTelegram = function (keyPair, recipientPublicKey, message, encrypted) {
        return __awaiter(this, void 0, void 0, function () {
            var recipient, pk, _a, tranBody, genesis_sign, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        recipient = {
                            address: recipientPublicKey,
                            publicKey: null,
                        };
                        if (!(recipientPublicKey.length >= 43)) return [3 /*break*/, 3];
                        return [4 /*yield*/, Base58_1.Base58.decode(recipientPublicKey)];
                    case 1:
                        pk = _c.sent();
                        _a = {};
                        return [4 /*yield*/, Qora_1.Qora.getAccountAddressFromPublicKey(pk)];
                    case 2:
                        recipient = (_a.address = _c.sent(),
                            _a.publicKey = pk,
                            _a);
                        _c.label = 3;
                    case 3:
                        tranBody = {
                            head: '',
                            message: message,
                            encrypted: encrypted,
                        };
                        if (!this.sidechainMode) return [3 /*break*/, 5];
                        return [4 /*yield*/, this.genesisSignature()];
                    case 4:
                        _b = _c.sent();
                        return [3 /*break*/, 6];
                    case 5:
                        _b = new Int8Array([]);
                        _c.label = 6;
                    case 6:
                        genesis_sign = _b;
                        return [4 /*yield*/, TranMessage_1.tranMessage(recipient, keyPair, tranBody, this.rpcPort, genesis_sign)];
                    case 7: return [2 /*return*/, _c.sent()];
                }
            });
        });
    };
    /** @description API send telegram.
     * @param {KeyPair} keyPair Key pair.
     * @param {string} recipientPublicKey Recipient public key.
     * @param {string} message Message.
     * @param {boolean} encrypted Encryption flag.
     * @return {Promise<IBroadcastResponse>}
     */
    API.prototype.sendTelegram = function (keyPair, recipientPublicKey, message, encrypted) {
        return __awaiter(this, void 0, void 0, function () {
            var recipient, pk, _a, tranBody, genesis_sign, _b, tran, data;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        recipient = {
                            address: recipientPublicKey,
                            publicKey: null,
                        };
                        if (!(recipientPublicKey.length >= 43)) return [3 /*break*/, 3];
                        return [4 /*yield*/, Base58_1.Base58.decode(recipientPublicKey)];
                    case 1:
                        pk = _c.sent();
                        _a = {};
                        return [4 /*yield*/, Qora_1.Qora.getAccountAddressFromPublicKey(pk)];
                    case 2:
                        recipient = (_a.address = _c.sent(),
                            _a.publicKey = pk,
                            _a);
                        _c.label = 3;
                    case 3:
                        tranBody = {
                            head: '',
                            message: message,
                            encrypted: encrypted,
                        };
                        if (!this.sidechainMode) return [3 /*break*/, 5];
                        return [4 /*yield*/, this.genesisSignature()];
                    case 4:
                        _b = _c.sent();
                        return [3 /*break*/, 6];
                    case 5:
                        _b = new Int8Array([]);
                        _c.label = 6;
                    case 6:
                        genesis_sign = _b;
                        return [4 /*yield*/, TranMessage_1.tranMessage(recipient, keyPair, tranBody, this.rpcPort, genesis_sign)];
                    case 7:
                        tran = _c.sent();
                        if (!!tran.error) return [3 /*break*/, 9];
                        return [4 /*yield*/, this.request.broadcast.telegramPost(tran.raw).catch(function (e) {
                                throw new Error(e);
                            })];
                    case 8:
                        data = _c.sent();
                        return [2 /*return*/, data];
                    case 9: throw new Error(tran.error);
                }
            });
        });
    };
    /** @description API raw data for registering asset.
     * @param {KeyPair} keyPair Key pair.
     * @param {string} name Asset name.
     * @param {number} assetType Asset type.
     * @param {number} quantity Quantity.
     * @param {number} scale Scale.
     * @param {Int8Array} icon Icon.
     * @param {Int8Array} image Image.
     * @param {string} description Description.
     * @return {Promise<ITranRaw>}
     */
    API.prototype.tranRawAsset = function (keyPair, name, assetType, quantity, scale, icon, image, description, isBase64, iconType, imageType) {
        return __awaiter(this, void 0, void 0, function () {
            var genesis_sign, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!this.sidechainMode) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.genesisSignature()];
                    case 1:
                        _a = _b.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        _a = new Int8Array([]);
                        _b.label = 3;
                    case 3:
                        genesis_sign = _a;
                        return [4 /*yield*/, TranAsset_1.tranAsset(keyPair, name, assetType, quantity, scale, icon, image, description, this.rpcPort, genesis_sign, isBase64, iconType, imageType)];
                    case 4: return [2 /*return*/, _b.sent()];
                }
            });
        });
    };
    /** @description API register asset.
     * @param {KeyPair} keyPair Key pair.
     * @param {string} name Asset name.
     * @param {number} assetType Asset type.
     * @param {number} quantity Quantity.
     * @param {number} scale Scale.
     * @param {Int8Array} icon Icon.
     * @param {Int8Array} image Image.
     * @param {string} description Description.
     * @return {Promise<IBroadcastResponse>}
     */
    API.prototype.registerAsset = function (keyPair, name, assetType, quantity, scale, icon, image, description, isBase64, iconType, imageType) {
        return __awaiter(this, void 0, void 0, function () {
            var genesis_sign, _a, tran, data, data;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!this.sidechainMode) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.genesisSignature()];
                    case 1:
                        _a = _b.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        _a = new Int8Array([]);
                        _b.label = 3;
                    case 3:
                        genesis_sign = _a;
                        return [4 /*yield*/, TranAsset_1.tranAsset(keyPair, name, assetType, quantity, scale, icon, image, description, this.rpcPort, genesis_sign, isBase64, iconType, imageType)];
                    case 4:
                        tran = _b.sent();
                        if (!!tran.error) return [3 /*break*/, 9];
                        if (!isBase64) return [3 /*break*/, 6];
                        return [4 /*yield*/, this.request.broadcast.broadcastPost64(tran.raw).catch(function (e) {
                                throw new Error(e);
                            })];
                    case 5:
                        data = _b.sent();
                        return [2 /*return*/, data];
                    case 6: return [4 /*yield*/, this.request.broadcast.broadcastPost(tran.raw).catch(function (e) {
                            throw new Error(e);
                        })];
                    case 7:
                        data = _b.sent();
                        return [2 /*return*/, data];
                    case 8: return [3 /*break*/, 10];
                    case 9: throw new Error(tran.error);
                    case 10: return [2 /*return*/];
                }
            });
        });
    };
    /** @description API send documents.
     * @param {KeyPair} keyPair Key pair.
     * @param {string} exData Metadata of documents.
     * @return {Promise<IBroadcastResponse>}
     */
    API.prototype.sendDocuments = function (keyPair, exData, isBase64) {
        return __awaiter(this, void 0, void 0, function () {
            var genesis_sign, _a, dataBytes, tran, data, data;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!this.sidechainMode) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.genesisSignature()];
                    case 1:
                        _a = _b.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        _a = new Int8Array([]);
                        _b.label = 3;
                    case 3:
                        genesis_sign = _a;
                        return [4 /*yield*/, exData.toBytes()];
                    case 4:
                        dataBytes = _b.sent();
                        return [4 /*yield*/, TranDocument_1.tranDocument(keyPair, dataBytes, this.rpcPort, genesis_sign, isBase64)];
                    case 5:
                        tran = _b.sent();
                        if (!!tran.error) return [3 /*break*/, 10];
                        if (!isBase64) return [3 /*break*/, 7];
                        return [4 /*yield*/, this.request.broadcast.broadcastPost64(tran.raw).catch(function (e) {
                                throw new Error(e);
                            })];
                    case 6:
                        data = _b.sent();
                        return [2 /*return*/, data];
                    case 7: return [4 /*yield*/, this.request.broadcast.broadcastPost(tran.raw).catch(function (e) {
                            throw new Error(e);
                        })];
                    case 8:
                        data = _b.sent();
                        return [2 /*return*/, data];
                    case 9: return [3 /*break*/, 11];
                    case 10: throw new Error(tran.error);
                    case 11: return [2 /*return*/];
                }
            });
        });
    };
    /** @description API: gets raw of documents.
     * @param {KeyPair} keyPair Key pair.
     * @param {string} exData Metadata of documents.
     * @return {Promise<string>}
     */
    API.prototype.tranRawDocuments = function (keyPair, exData, isBase64) {
        return __awaiter(this, void 0, void 0, function () {
            var genesis_sign, _a, dataBytes;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!this.sidechainMode) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.genesisSignature()];
                    case 1:
                        _a = _b.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        _a = new Int8Array([]);
                        _b.label = 3;
                    case 3:
                        genesis_sign = _a;
                        return [4 /*yield*/, exData.toBytes()];
                    case 4:
                        dataBytes = _b.sent();
                        return [4 /*yield*/, TranDocument_1.tranDocument(keyPair, dataBytes, this.rpcPort, genesis_sign, isBase64)];
                    case 5: return [2 /*return*/, _b.sent()];
                }
            });
        });
    };
    /** @description API: Sign other transaction.
     * @param {KeyPair} keyPair Key pair.
     * @param {string} seqNo String format - `Height of block-Number in block`.
     * @return {Promise<string>}
     */
    API.prototype.tranRawSign = function (keyPair, seqNo, isBase64) {
        return __awaiter(this, void 0, void 0, function () {
            var genesis_sign, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!this.sidechainMode) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.genesisSignature()];
                    case 1:
                        _a = _b.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        _a = new Int8Array([]);
                        _b.label = 3;
                    case 3:
                        genesis_sign = _a;
                        return [4 /*yield*/, TranSign_1.tranSign(keyPair, seqNo, this.rpcPort, genesis_sign, isBase64)];
                    case 4: return [2 /*return*/, _b.sent()];
                }
            });
        });
    };
    /** @description API: Gets raw data for create a unique imprint.
     * @param {KeyPair} keyPair Key pair.
     * @param {string} name Imprint name.
     * @param {Int8Array} icon Icon.
     * @param {Int8Array} image Image.
     * @param {string} description Description.
     * @return {Promise<ITranRaw>}
     */
    API.prototype.tranRawImprint = function (keyPair, names, icon, image, description, isBase64) {
        return __awaiter(this, void 0, void 0, function () {
            var genesis_sign, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!this.sidechainMode) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.genesisSignature()];
                    case 1:
                        _a = _b.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        _a = new Int8Array([]);
                        _b.label = 3;
                    case 3:
                        genesis_sign = _a;
                        return [4 /*yield*/, TranImprint_1.tranImprint(keyPair, names, icon, image, description, this.rpcPort, genesis_sign, isBase64)];
                    case 4: return [2 /*return*/, _b.sent()];
                }
            });
        });
    };
    /** @description API: Gets raw data for create a template.
     * @param {KeyPair} keyPair Key pair.
     * @param {string} name Template name.
     * @param {Int8Array} icon Icon.
     * @param {Int8Array} image Image.
     * @param {string} description Description.
     * @return {Promise<ITranRaw>}
     */
    API.prototype.tranRawTemplate = function (keyPair, name, icon, image, description, isBase64) {
        return __awaiter(this, void 0, void 0, function () {
            var genesis_sign, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!this.sidechainMode) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.genesisSignature()];
                    case 1:
                        _a = _b.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        _a = new Int8Array([]);
                        _b.label = 3;
                    case 3:
                        genesis_sign = _a;
                        return [4 /*yield*/, TranTemplate_1.tranTemplate(keyPair, name, icon, image, description, this.rpcPort, genesis_sign, isBase64)];
                    case 4: return [2 /*return*/, _b.sent()];
                }
            });
        });
    };
    /** @description API: Gets raw data for create order.
     * @param {KeyPair} keyPair Key pair.
     * @param {string} name Name.
     * @param {number} haveAssetKey Asset key on hand.
     * @param {number} haveAmount Amount of assets at hand.
     * @param {number} wantAssetKey Want such an asset key.
     * @param {number} wantAmount Want amount assets.
     * @return {Promise<ITranRaw>}
     */
    API.prototype.tranRawOrder = function (keyPair, name, haveAssetKey, haveAmount, wantAssetKey, wantAmount, isBase64) {
        return __awaiter(this, void 0, void 0, function () {
            var genesis_sign, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!this.sidechainMode) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.genesisSignature()];
                    case 1:
                        _a = _b.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        _a = new Int8Array([]);
                        _b.label = 3;
                    case 3:
                        genesis_sign = _a;
                        return [4 /*yield*/, TranOrder_1.tranOrder(keyPair, name, haveAssetKey, haveAmount, wantAssetKey, wantAmount, this.rpcPort, genesis_sign, isBase64)];
                    case 4: return [2 /*return*/, _b.sent()];
                }
            });
        });
    };
    /** @description API: Gets raw data for cancel order.
     * @param {KeyPair} keyPair Key pair.
     * @param {string} name Name.
     * @param {string} signature Signature of order.
     * @return {Promise<ITranRaw>}
     */
    API.prototype.tranRawCancelOrder = function (keyPair, name, signature, isBase64) {
        return __awaiter(this, void 0, void 0, function () {
            var genesis_sign, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!this.sidechainMode) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.genesisSignature()];
                    case 1:
                        _a = _b.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        _a = new Int8Array([]);
                        _b.label = 3;
                    case 3:
                        genesis_sign = _a;
                        return [4 /*yield*/, TranCancelOrder_1.tranCancelOrder(keyPair, name, signature, this.rpcPort, genesis_sign, isBase64)];
                    case 4: return [2 /*return*/, _b.sent()];
                }
            });
        });
    };
    /** @description API: Gets raw data for cancel order.
     * @param {KeyPair} keyPair Key pair.
     * @param {string} name Name.
     * @param {string} signature Signature of order.
     * @param {number} wantAmount Want amount assets.
     * @return {Promise<ITranRaw>}
     */
    API.prototype.tranRawUpdateOrder = function (keyPair, name, signature, wantAmount, isBase64, forHave) {
        return __awaiter(this, void 0, void 0, function () {
            var genesis_sign, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!this.sidechainMode) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.genesisSignature()];
                    case 1:
                        _a = _b.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        _a = new Int8Array([]);
                        _b.label = 3;
                    case 3:
                        genesis_sign = _a;
                        return [4 /*yield*/, TranUpdateOrder_1.tranUpdateOrder(keyPair, name, signature, wantAmount, this.rpcPort, genesis_sign, isBase64, forHave)];
                    case 4: return [2 /*return*/, _b.sent()];
                }
            });
        });
    };
    /** @description API gets raw transaction, send amount of asset to recipient to debt.
     * @param {KeyPair} keyPair Key pair.
     * @param {IAsset} asset Amount and asset key.
     * @param {string} recipientPublicKey Recipient public key.
     * @param {string} head Title.
     * @param {string} message Message.
     * @param {boolean} encrypted Encryption flag.
     * @param {boolean} isBase64 Base64 encoding.
     * @return {Promise<IBroadcastResponse>}
     */
    API.prototype.tranRawDebt = function (keyPair, asset, recipientPublicKey, head, message, encrypted, isBase64) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.tranRawSendAsset(keyPair, asset, recipientPublicKey, head, message, encrypted, isBase64, TranTypes_1.ETransferType.DEBT)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /** @description API gets raw transaction, send amount of asset to recipient to return debt.
     * @param {KeyPair} keyPair Key pair.
     * @param {IAsset} asset Amount and asset key.
     * @param {string} recipientPublicKey Recipient public key.
     * @param {string} head Title.
     * @param {string} message Message.
     * @param {boolean} encrypted Encryption flag.
     * @param {boolean} isBase64 Base64 encoding.
     * @return {Promise<IBroadcastResponse>}
     */
    API.prototype.tranRawReturnDebt = function (keyPair, asset, recipientPublicKey, head, message, encrypted, isBase64) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.tranRawSendAsset(keyPair, asset, recipientPublicKey, head, message, encrypted, isBase64, TranTypes_1.ETransferType.RETURN_DEBT)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /** @description API gets raw transaction, send amount of asset to recipient to confiscate debt.
     * @param {KeyPair} keyPair Key pair.
     * @param {IAsset} asset Amount and asset key.
     * @param {string} recipientPublicKey Recipient public key.
     * @param {string} head Title.
     * @param {string} message Message.
     * @param {boolean} encrypted Encryption flag.
     * @param {boolean} isBase64 Base64 encoding.
     * @return {Promise<IBroadcastResponse>}
     */
    API.prototype.tranRawConfiscateDebt = function (keyPair, asset, recipientPublicKey, head, message, encrypted, isBase64) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.tranRawSendAsset(keyPair, asset, recipientPublicKey, head, message, encrypted, isBase64, TranTypes_1.ETransferType.CONFISCATE_DEBT)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /** @description API gets raw transaction, send amount of asset to recipient to take.
     * @param {KeyPair} keyPair Key pair.
     * @param {IAsset} asset Amount and asset key.
     * @param {string} recipientPublicKey Recipient public key.
     * @param {string} head Title.
     * @param {string} message Message.
     * @param {boolean} encrypted Encryption flag.
     * @param {boolean} isBase64 Base64 encoding.
     * @return {Promise<IBroadcastResponse>}
     */
    API.prototype.tranRawTake = function (keyPair, asset, recipientPublicKey, head, message, encrypted, isBase64) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.tranRawSendAsset(keyPair, asset, recipientPublicKey, head, message, encrypted, isBase64, TranTypes_1.ETransferType.TAKE)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /** @description API gets raw transaction, send amount of asset to recipient to spend.
     * @param {KeyPair} keyPair Key pair.
     * @param {IAsset} asset Amount and asset key.
     * @param {string} recipientPublicKey Recipient public key.
     * @param {string} head Title.
     * @param {string} message Message.
     * @param {boolean} encrypted Encryption flag.
     * @param {boolean} isBase64 Base64 encoding.
     * @return {Promise<IBroadcastResponse>}
     */
    API.prototype.tranRawSpend = function (keyPair, asset, recipientPublicKey, head, message, encrypted, isBase64) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.tranRawSendAsset(keyPair, asset, recipientPublicKey, head, message, encrypted, isBase64, TranTypes_1.ETransferType.SPEND)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /** @description API gets raw transaction, send amount of asset to recipient to pledge.
     * @param {KeyPair} keyPair Key pair.
     * @param {IAsset} asset Amount and asset key.
     * @param {string} recipientPublicKey Recipient public key.
     * @param {string} head Title.
     * @param {string} message Message.
     * @param {boolean} encrypted Encryption flag.
     * @param {boolean} isBase64 Base64 encoding.
     * @return {Promise<IBroadcastResponse>}
     */
    API.prototype.tranRawPledge = function (keyPair, asset, recipientPublicKey, head, message, encrypted, isBase64) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.tranRawSendAsset(keyPair, asset, recipientPublicKey, head, message, encrypted, isBase64, TranTypes_1.ETransferType.PLEDGE)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /** @description API gets raw transaction, send amount of asset to recipient to return pledge.
     * @param {KeyPair} keyPair Key pair.
     * @param {IAsset} asset Amount and asset key.
     * @param {string} recipientPublicKey Recipient public key.
     * @param {string} head Title.
     * @param {string} message Message.
     * @param {boolean} encrypted Encryption flag.
     * @param {boolean} isBase64 Base64 encoding.
     * @return {Promise<IBroadcastResponse>}
     */
    API.prototype.tranRawReturnPledge = function (keyPair, asset, recipientPublicKey, head, message, encrypted, isBase64) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.tranRawSendAsset(keyPair, asset, recipientPublicKey, head, message, encrypted, isBase64, TranTypes_1.ETransferType.RETURN_PLEDGE)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    API.CHAIN_MODE = IApiConfig_1.ChainMode.DEFAULT;
    return API;
}());
exports.API = API;
